import React from "react";
import { IconX } from "@tabler/icons-react";
import SubmitButton from "./SubmitButton";
 

type Props = {
  closeButtonText?: string;
  actionButtonOnClick?: () => void;
  actionButtonText?: string;
  onClose: () => void;
  title: string;
  subtitle?: React.ReactNode;
  open: boolean;
  img?: string;
  showFooter?: boolean;
  size?: "sm" | "md" | "lg";
  isPending?: boolean;
  children?: React.ReactNode;
};

const MessageModal = ({
  open,
  onClose,
  title,
  subtitle,
  img,
  actionButtonOnClick,
  closeButtonText = "Cancel",
  actionButtonText = "Confirm",
  showFooter = true,
  size = "md",
  isPending,
  children, // ✅ Destructure the children prop here
}: Props) => {
  if (!open) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-lg",
    lg: "max-w-xl",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6">
      {/* Modal Box */}
      <div
        className={`relative w-full rounded-2xl bg-white shadow-xl ${sizeClasses[size]}`}
      >
        {/* Modal Content */}
        <div className="flex flex-col items-center px-6 py-10 text-center">
          {/* Image Icon */}
          <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-yellow-100">
            <img src={img} alt={title} className="h-12 w-12 object-contain" />
          </div>

          <div>
            {/* Title */}
            <h2 className="text-2xl font-semibold text-[#212121]">{title}</h2>

            {/* Subtitle */}
            {subtitle && (
              <p className=" text-gray-600 text-base leading-6">{subtitle}</p>
            )}
          </div>
          {/* ✅ Conditionally render children if they exist */}
          {children && <div className="mt-4 w-full">{children}</div>}

          {/* Footer */}
          {showFooter && (
            <div className="mt-8 flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-center sm:gap-4">
              <button
                onClick={onClose}
                className="w-full sm:w-auto rounded-full border border-gray-300 bg-white px-6 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 transition"
              >
                {closeButtonText}
              </button>

              <SubmitButton
                onClick={actionButtonOnClick}
                isPending={isPending}
                type="button"
              >
                {actionButtonText}
              </SubmitButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
